export default __webpack_public_path__ + "static/media/Group6374@3x.ca660eb4.png";